export default __webpack_public_path__ + "static/media/0000..0007.77e0de44.png";